import { useEffect, useRef, useState } from 'react';
import ErrorModal from '../../../../../../component/ErrorModal/ErrorModal';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getProductBatchList, getProductList } from '../../../../../../services/products';
import { taxesCalculation } from '../../../../components/TaxesCalculation';
import { getDate } from '../../../../../../utils/dateUtils';
import AddProductModel from '../../components/addProductModel';
import AddProductBatchModel from '../../components/addProductBatchModel';
import { useSelector } from 'react-redux';
import { mergeUniqueById } from '../../../../../../utils/controller';
import { iconFormatTag } from '../../../../../../utils/constant';

const InvoiceProductTable = ({
	initialRows,
	isDraft,
	tableError,
	className,
	setTableError,
	invoiceTable,
	setInvoiceTable,
	productsList,
	columns,
}) => {
	const inputRefs = useRef([]);
	const param = useParams();
	const id = param?.id;
	const [showError, setShowError] = useState(false);
	const [isOpenProductModel, setIsOpenProductModel] = useState(false);
	const [isOpenProductBatchModel, setIsOpenProductBatchModel] = useState(false);
	const [batchList, setBatchList] = useState([]);
	const [productList, setProductList] = useState([]);
	const [tableIndex, setTableIndex] = useState(null);
	const ErrorModalOpen = () => {
		setShowError(true);
	};

	const getToolTipData = (name) => {
		switch (name) {
			case 'product_id':
				return 'Product Name can not be empty.';
			case 'batch_no':
				return 'Batch No can not be empty';
			case 'expiry_date':
				return 'Expire date can not be empty';
			case 'mrp':
				return 'MRP can not be empty';
			case 'quantity':
				return 'Quantity can not be empty or 0';
			case 'amount':
				return `Amount can not empty`;
			default:
				return '';
		}
	};

	async function fetchProduct(param) {
		try {
			const productList = await getProductList(param);
			let productOptions = productList?.productWithStockCount?.map((ele) => ({
				key: ele?.product_id,
				value: ele?.product_name,
			}));
			const data = mergeUniqueById(productOptions, productsList);
			setProductList(data);
		} catch (error) {
			toast.error('Something went wrong! while fetching the product list.');
		}
	}

	async function handleFetchBatchNumber(productId) {
		try {
			setBatchList([]);
			if (productId !== undefined && productId !== '' && productId !== null) {
				const data = await getProductBatchList({ product_id: productId });
				const productBatches =
					data?.length > 0
						? data?.map((batch) => {
								return {
									key: batch?.product_batch_id,
									value: batch?.batch_no,
									qty: batch?.quantity,
									mrp: batch?.mrp,
									expiry_date: getDate(batch?.expiry_date, false, false, true),
									tag:
										batch?.tags.length > 0
											? batch?.tags.includes('expired')
												? 'expired'
												: batch?.tags.includes('near_expiry')
													? 'near_expiry'
													: batch?.tags[0]
											: '',
								};
							})
						: [];
				setBatchList(productBatches);
			}
		} catch (error) {
			setBatchList([]);
			toast.error('Something went wrong!');
		}
	}

	const handleBatchChange = async (index, value, indexName) => {
		let name = indexName;
		let newRows = [...invoiceTable];
		if (value) {
			if (
				batchList &&
				newRows[index].product_id !== '' &&
				newRows[index].product_id !== undefined
			) {
				const data = await getProductList({
					filterBy: 'product_id',
					filterValue: newRows[index].product_id,
				});
				let batchData = data?.productWithStockCount[0]?.product_batch?.filter(
					(row) => row.batch_no === value,
				);
				if (batchData) {
					newRows[index].expiry_date = batchData[0]?.expiry_date
						? getDate(batchData[0]?.expiry_date, false, false, true)
						: '';
					newRows[index].mrp = batchData[0]?.mrp ?? '0.00';
					newRows[index].product_batch_id = batchData[0]?.product_batch_id;
					const tags = batchList.find((data) => data.key === batchData[0]?.product_batch_id);
					// console.log(tags);
					if (tags && tags.tag !== undefined) {
						newRows[index].tag = tags.tag;
					}
				} else {
					newRows[index].expiry_date = '';
					newRows[index].mrp = '0.00';
					newRows[index].tag = null;
				}
			} else {
				newRows[index].expiry_date = '';
				newRows[index].mrp = '0.00';
				newRows[index].tag = null;
			}
			newRows[index][name] = value;
			console.log(newRows);
			let rowData = taxesCalculation(newRows, index);
			setInvoiceTable(rowData);
		} else {
			newRows[index].tag = null;
			newRows[index].exp_date = '';
			newRows[index].mrp = '0.00';
			newRows[index][name] = value;
			let totalAmount = Number(newRows[index].mrp ?? 0) * Number(newRows[index].quantity ?? 0);
			newRows[index].amount = totalAmount;
			setInvoiceTable(newRows);
		}

		let error = [...tableError.filter((er) => er.name !== 'batch_no')];
		const batchCount = {};
		newRows.forEach((row, i) => {
			if (!row.batch_no) {
				error.push({ index: i, name: 'batch_no' });
			}

			if (row.batch_no) {
				batchCount[row.batch_no] = (batchCount[row.batch_no] || 0) + 1;
			}
		});

		newRows.forEach((row, i) => {
			if (row.batch_no && batchCount[row.batch_no] > 1) {
				error.push({
					index: i,
					name: 'batch_no',
					customErrorMessage: {
						batch_no: 'This batch number already exists in the invoice.',
					},
				});
			}
		});
		setTableError(error);
	};

	const handleProductInputChange = async (index, value) => {
		setBatchList([]);
		const newRows = [...invoiceTable];
		const selectedProduct = productList?.find((prod) => prod?.key === value);
		newRows[index].product_id = selectedProduct?.key || '';
		var data;
		if (!isNaN(value) && value !== '') {
			data = await getProductList({
				filterBy: 'product_id',
				filterValue: value,
			});
		} else {
			data = null;
		}

		if (data != null && data?.productWithStockCount?.length > 0) {
			newRows[index].product_tax1 = data?.productWithStockCount[0]?.tax1 ?? 0;
			newRows[index].product_tax2 = data?.productWithStockCount[0]?.tax2 ?? 0;
			const batch = data?.productWithStockCount[0]?.product_batch?.map((ele) => ({
				key: ele.product_batch_id,
				value: ele.batch_no,
				qty: ele?.quantity,
				mrp: ele?.mrp,
				expiry_date: getDate(ele?.expiry_date, false, false, true),
				tag:
					ele?.tags && ele?.tags.length > 0
						? ele?.tags.includes('expired')
							? 'expired'
							: ele?.tags.includes('near_expiry')
								? 'near_expiry'
								: ele?.tags[0]
						: '',
			}));
			setBatchList(batch || []);
		} else {
			newRows[index].product_tax1 = 0;
			newRows[index].product_tax2 = 0;
			setBatchList([]);
		}

		let error = [...tableError.filter((er) => er.name !== 'product_id')];

		newRows.forEach((row, i) => {
			if (!row.product_id) {
				error.push({ index: i, name: 'product_id' });
			} else {
				error = error.filter((cell) => !(cell.index === index && cell.name === 'product_id'));
			}
		});

		newRows[index].product_id = value;
		newRows[index].batch_no = '';
		newRows[index].tag = null;
		newRows[index].expiry_date = '';
		newRows[index].mrp = '0.00';
		newRows[index].amount = '0';
		setInvoiceTable(newRows);
		setTableError(error);
	};

	const handleChange = (index, valueData, field) => {
		let value = '';

		if (field === 'expiry_date') {
			value = value.replace(/\D/g, '');

			if (value.length > 4) {
				value = value.slice(0, 4);
			}

			if (value.length >= 2) {
				let month = value.slice(0, 2);
				const year = value.slice(2);

				if (parseInt(month) > 12) {
					month = '12';
				}

				value = year ? `${month}/${year}` : month;
			}
		} else if (field === 'quantity') {
			value = valueData?.replace(/[^0-9]/g, '');
		} else {
			value = valueData?.replace(/[^0-9.]/g, '');
			const decimalCount = (value.match(/\./g) || []).length;
			if (decimalCount > 1) {
				value = +value?.slice(0, value.lastIndexOf('.'));
			}
		}

		let errors = [...tableError];
		const newRows = [...invoiceTable];

		if (field === 'expiry_date') {
		}

		if (field === 'mrp') {
			if (value === 0 || value === '') {
				errors.push({ index, name: 'mrp' });
			} else {
				errors = errors.filter((cell) => !(cell.index === index && cell.name === 'mrp'));
			}
			newRows[index].mrp = value;
		}

		if (field === 'quantity') {
			if (value === '' || Number(value) === 0) {
				errors.push({ index, name: field });
			} else {
				errors = errors.filter((cell) => !(cell.index === index && cell.name === field));
			}
		}

		setTableError(errors);

		newRows[index][field] = value;
		let rowData = taxesCalculation(newRows, index);

		setInvoiceTable(rowData);
	};

	const handleKeyDown = (index, event) => {
		let { name, value } = event.target;
		if (event.key === 'Enter') {
			const column = columns.find((col) => col.name === name);
			if (column && column.label === 'QTY') {
				addRow();
			}
		}
	};

	useEffect(() => {
		handleChangeTable();
	}, []);

	useEffect(() => {
		if (id && productsList.length > 0) {
			handleChangeTable();
		}
	}, [productsList]);

	const handleChangeTable = () => {
		let param = {
			page: 1,
			pageSize: 2000,
			filterBy: 'status',
			filterValue: '1',
		};
		fetchProduct(param);
		if (invoiceTable.length === 0) {
			setInvoiceTable(initialRows);
		}
	};

	const CloseErrorModal = () => {
		setShowError(false);
		setTimeout(() => {
			if (invoiceTable.length > 0) {
				inputRefs.current[invoiceTable.length - 1]?.[0]?.focus();
			}
		}, 0);
	};

	const handleRef = (rowIndex, cellIndex) => (el) => {
		if (!inputRefs.current[rowIndex]) {
			inputRefs.current[rowIndex] = [0];
		}
		inputRefs.current[rowIndex][cellIndex] = el;
	};

	const addRow = () => {
		const newRows = [...invoiceTable, initialRows[0]];
		setInvoiceTable(newRows);

		if (newRows.length > 1) {
			const secondLastRowIndex = newRows.length - 2;
			const secondLastRow = newRows[secondLastRowIndex];
			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];

					return (
						(value === null ||
							value === '' ||
							value === '0.00' ||
							value === 'MM/YY' ||
							Number(value) === 0) &&
						['product_id', 'batch_no', 'quantity'].includes(col.name)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));

			setTableError((prevError) => [
				...prevError.filter(
					(er) =>
						!(
							er.index === secondLastRowIndex &&
							(er.customErrorMessage === null || er.customErrorMessage === undefined)
						),
				),
				...errors,
			]);

			setTimeout(() => {
				inputRefs.current[newRows.length - 1]?.[0]?.focus();
				let lastRowRef = inputRefs.current[newRows.length - 1]?.[0];
				lastRowRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}, 0);
		}
	};

	const deleteRow = (index) => {
		if (invoiceTable.length > 1) {
			const newRows = [...invoiceTable];
			newRows.splice(index, 1);

			// Step 1: Remove old errors and re-index them
			let newTableError = tableError
				.filter((error) => error.index !== index)
				.map((error) => ({
					...error,
					index: error.index > index ? error.index - 1 : error.index,
				}));

			// Step 2: Remove all batch_no errors (we will recalculate)
			newTableError = newTableError.filter((error) => error.name !== 'batch_no');

			// Step 3: Recalculate duplicate batch errors
			const batchCount = {};
			newRows.forEach((row) => {
				if (row.batch_no) {
					batchCount[row.batch_no] = (batchCount[row.batch_no] || 0) + 1;
				}
			});

			newRows.forEach((row, i) => {
				if (row.batch_no && batchCount[row.batch_no] > 1) {
					newTableError.push({
						index: i,
						name: 'batch_no',
						customErrorMessage: {
							batch_no: 'This batch number already exists in the invoice.',
						},
					});
				}
			});

			setTableError(newTableError);
			setInvoiceTable(newRows);
			setTimeout(() => {
				inputRefs.current[newRows.length - 1]?.[0]?.focus();
			}, 0);
		} else if (!id) {
			setInvoiceTable(initialRows);
			setTableError([]);
			setTimeout(() => {
				inputRefs.current[0]?.[0]?.focus();
			}, 0);
		}
	};

	const checkErrorInTable = () => {
		if (invoiceTable?.length > 0 && tableError.length > 0) {
			const secondLastRowIndex = invoiceTable.length - 1;
			const secondLastRow = invoiceTable[secondLastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];

					return (
						(value === null || value === '' || value === '0.00' || Number(value) === 0) &&
						['product_id', 'batch_no', 'quantity'].includes(col.name)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));

			setTableError((prevErrorCells) => [
				...prevErrorCells.filter(
					(er) =>
						!(
							er.index === secondLastRowIndex &&
							(er.customErrorMessage === null || er.customErrorMessage === undefined)
						),
				),
				...errors,
			]);
		}
	};

	return (
		<>
			{tableError && tableError?.length > 0 && (
				<div className="d-flex justify-content-end  text-danger  mb-0">
					{' '}
					<span
						style={{ textDecoration: 'underline', cursor: 'pointer' }}
						onClick={ErrorModalOpen}
					>
						Show all error
					</span>
				</div>
			)}
			<div className="text-center mb-2 custum_table">
				<div>
					<table>
						<thead>
							<tr>
								{columns.map((col) => (
									<th
										style={{
											width:
												(col.name === 'product_id' && '40%') || (col.name === 'batch_no' && '20%'),
										}}
										className={`${className}`}
										key={col.name}
									>
										<div
											style={{
												display: 'flex',
												justifyItems: 'start',
												alignItems: 'center',
											}}
										>
											<span>{col.label}</span>
											<span style={{ color: 'red' }}>
												{[
													'product_id',
													'batch_no',
													'expiry_date',
													'mrp',
													'quantity',
													'amount',
												].includes(col.name)
													? '*'
													: ''}
											</span>
											{[
												'product_id',
												'batch_no',
												'expiry_date',
												'mrp',
												'quantity',
												'amount',
											].includes(col.name) ? (
												<i className="toolTip_custum fa fa-info-circle">
													<span className="toolTip_custumtext">{getToolTipData(col.name)}</span>
												</i>
											) : (
												''
											)}
										</div>
									</th>
								))}
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{invoiceTable.map((row, rowIndex) => (
								<tr key={rowIndex}>
									{columns.map((col, cellIndex) => (
										<td key={col.name}>
											{col.type === 'batch_no' ? (
												<InputSelect
													placeholder="Select Batch No"
													value={
														batchList?.find((option) => option.value === row[col.name])?.value ||
														row[col.name]
													}
													onChange={(value) => {
														handleBatchChange(rowIndex, value, col?.name);
													}}
													onSelect={(option) => {
														handleBatchChange(rowIndex, option.value, col?.name);
													}}
													options={batchList}
													returnInputValue={false}
													isLocalValidationError={
														tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? true
															: false
													}
													onAddNew={() => {
														if (
															row?.product_id !== undefined &&
															row?.product_id !== null &&
															row?.product_id !== ''
														) {
															console.log(row?.product_id);
															setIsOpenProductBatchModel(true);
															setTableIndex(rowIndex);
														} else {
															toast.error('Please first select product in current table');
														}
													}}
													leftIcons={
														invoiceTable[rowIndex].product_batch_id !== null &&
														invoiceTable[rowIndex].product_batch_id &&
														invoiceTable[rowIndex].tag
															? [
																	{
																		src: iconFormatTag(invoiceTable[rowIndex].tag),
																		alt: 'Batch Tags',
																		onClick: () => {},
																	},
																]
															: []
													}
													onClickDropdownIcon={() => {
														if (row?.product_id !== undefined && row?.product_id !== null) {
															handleFetchBatchNumber(row?.product_id);
														}
													}}
													onfucusCapture={(e) => {
														if (row?.product_id !== undefined && row?.product_id !== null) {
															handleFetchBatchNumber(row?.product_id);
														}
													}}
												/>
											) : col.type === 'product_name' ? (
												<InputSelect
													placeholder="Select Product"
													value={row[col.name]}
													onChange={(value) => {
														handleProductInputChange(rowIndex, value);
													}}
													onSelect={(option) => {
														if (option?.key !== row[col.name]) {
															handleProductInputChange(rowIndex, option.key);
														}
													}}
													onKeyDownCb={(e) => {}}
													isLocalValidationError={
														tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? true
															: false
													}
													onAddNew={() => {
														setIsOpenProductModel(true);
														setTableIndex(rowIndex);
													}}
													options={productList}
													returnInputValue={false}
													propInputRef={handleRef(rowIndex, cellIndex)}
												/>
											) : col.type === 'date' ? (
												<input
													type="text"
													name={col.name}
													value={row[col.name]}
													style={{
														border: '1px solid rgba(85, 91, 103, 0.15)',
														borderRadius: '8px',
														height: '38px',
													}}
													onChange={(e) => {
														handleChange(rowIndex, e.target.value, col.name);
													}}
													disabled={true}
													onKeyDown={(e) => handleChange(rowIndex, e.target.value, col.name)}
													placeholder="MM/YY"
													maxLength="5"
													className="table_input"
													ref={handleRef(rowIndex, cellIndex)}
												/>
											) : (
												<input
													className="table_input"
													type={col.type}
													name={col.name}
													value={row[col.name]}
													style={{
														border: tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? '1px solid red'
															: '1px solid rgba(85, 91, 103, 0.15)',
														borderRadius: '8px',
														height: '38px',
													}}
													disabled={col.name === 'mrp' || col.name === 'amount'}
													onChange={(e) => {
														handleChange(rowIndex, e.target.value, col.name);
													}}
													onKeyDown={(e) => {
														handleKeyDown(rowIndex, e);
													}}
													ref={handleRef(rowIndex, cellIndex)}
												/>
											)}
										</td>
									))}

									<td>
										{id !== undefined && invoiceTable.length === 1 ? (
											<></>
										) : (
											<button
												className="delete mt-0 bg-transparent"
												onClick={() => deleteRow(rowIndex)}
												tabIndex="-1"
											>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
												>
													<path
														d="M3 6H5H21"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M10 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M14 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											</button>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				{
					<span style={{ display: 'flex', justifyContent: 'right' }}>
						<button
							className="bg-transparent text-dark add-new-row-button mt-2"
							onClick={addRow}
						>
							Add New Row
							<i
								className="fa fa-plus"
								style={{
									marginLeft: '.5rem',
									strokeWidth: '.1rem',
									color: 'var(--brand-color)',
									WebkitTextStrokeColor: '#fff',
									WebkitTextStrokeWidth: '1px',
								}}
							/>
						</button>
					</span>
				}
			</div>
			{isOpenProductModel && (
				<AddProductModel
					isOpenProductModal={isOpenProductModel}
					setIsOpenProductModal={setIsOpenProductModel}
					getProductList={(data) => fetchProduct(data)}
					tableIndex={tableIndex}
					invoiceTable={invoiceTable}
					setInvoiceTable={setInvoiceTable}
				/>
			)}
			{isOpenProductBatchModel && (
				<AddProductBatchModel
					isOpenProductBatchModel={isOpenProductBatchModel}
					setIsOpenProductBatchModel={setIsOpenProductBatchModel}
					getProductBatchList={(id) => handleFetchBatchNumber(id)}
					tableIndex={tableIndex}
					invoiceTable={invoiceTable}
					setInvoiceTable={setInvoiceTable}
				/>
			)}

			<div className="text-start">
				{showError && (
					<ErrorModal
						show={showError}
						isOpen={showError}
						onClose={CloseErrorModal}
						title="Error in Add Inventory Table"
						error={tableError}
					/>
				)}
			</div>
		</>
	);
};
export default InvoiceProductTable;
